import {useEffect} from 'react'

const useGuard = (predicate: boolean, onFail: () => void) => {
  useEffect(() => {
    if (!predicate) {
      onFail()
    }
  }, [predicate, onFail])

  return !predicate
}

export default useGuard
